import React, { useState, useEffect } from 'react';
import "./footer.css"
import { Link } from "react-router-dom";

const footer = () => {

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
        if (window.scrollY > 300) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth', // Smooth scrolling
        });
    };
    
  return (
    <>

          <div class="container-fluid bg-dark footer mt-1 wow fadeIn" data-wow-delay="0.1s" >
              <div class="container py-3">
                  <div class="row g-5">
                      <div class="col-lg-3 col-md-6" style={{ textAlign: 'left' }}>
                            <a href="/" class="navbar-brand">
                                <img src="airlogo.png" alt="Aura Lanka Logo" width="250" height="250"></img>
                            </a>
                          {/* <h1 class="text-white mb-4"  style={{ textAlign: 'left' }}>
                              <i class="fa fa-building text-primary me-3"></i>APEX
                          </h1> */}
                          {/* <p>
                            Aura Airlines is a concept of conglomerate in the Airline Industry in Sri Lanka dedicating its approach mainly to Private & Business Airline, as an exclusive platform which customers can benefit from in the fields of Leisure, Corporate and VIP transport solutions, and service for both domestic and international market.
                          </p> */}
                          
                      </div>
                      <div class="col-lg-3 col-md-6">
                          <h4 class="text-light mb-4" style={{ textAlign: 'left' }}>Address</h4>
                          <p class="text-light"><i class="fa fa-envelope me-3"></i>info@auraailines.com</p>
                          <p class="text-light"><i class="fa fa-phone-alt me-3"></i>+94 77 907 1437</p>
                          {/* <p><i class="fa fa-user me-3"></i>Dr. Viranjith Thambugala</p> */}
                          <p class="text-light">
                              <i class="fa fa-map-marker-alt me-3"></i>949/13, Udawatta Road, Thalangama North, Malabe
                          </p>
                          <p class="text-light">
                              <i class="fa fa-map-marker-alt me-3"></i>Colombo International Airport. Ratmalana, Sri Lanka
                          </p>

                         
                          
                      </div>
                      <div class="col-lg-3 col-md-6"  style={{ textAlign: 'left' }}>
                          <h4 class="text-light mb-4">Quick Links</h4>
                          <Link className="btn btn-link text-light" to="/">Home</Link>
                          <Link className="btn btn-link text-light" to="/about">About</Link>
                          <Link className="btn btn-link text-light" to="/Membership">Membership</Link>
                          <Link className="btn btn-link text-light" to="/Destination">Destinations</Link>
                          <Link className="btn btn-link text-light" to="/Offers">Offers</Link>
                          <Link className="btn btn-link text-light" to="/Inquire">Inquire</Link>
                      </div>
                      <div class="col-lg-3 col-md-6">
                          <h4 class="text-light mb-4"  style={{ textAlign: 'left' }}>Newsletter</h4>
                          <p class="text-light" style={{ fontSize: '18px', fontWeight: 'bold' }}>Get in touch for latest updates.</p>
                          <div class="position-relative mx-auto" style={{ maxWidth: '400px' }}>
                              <input
                                  class="form-control  w-100 py-3 ps-4 pe-5"
                                  type="text"
                                  placeholder="Your email"
                              />
                              <button
                                  type="button"
                                  class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                              >
                                  SignUp
                              </button>
                              
                          </div>
                          <br />
                          <div class="d-flex pt-2">
                            <a class="btn btn-square btn-outline-primary-footer me-1 text-light" href="https://www.facebook.com/viranjiththambugala"><i class="fab fa-facebook-f "></i></a>
                            <a class="btn btn-square btn-outline-primary-footer me-1 text-light" href="https://www.youtube.com/watch?v=KkQATIXBY5w"><i class="fab fa-twitter"></i></a>
                            <a class="btn btn-square btn-outline-primary-footer me-1 text-light" href="https://www.youtube.com/watch?v=KkQATIXBY5w"><i class="fab fa-youtube"></i></a>
                            <a class="btn btn-square btn-outline-primary-footer me-0 text-light" href="/"><i class="fab fa-instagram"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="container-fluid copyright">
                  <div class="container">
                      <div class="row">
                          <div class="col-md-12 text-center mb-3 mb-md-0" style={{ color: '#dadadae7' }}>
                              &copy; <a href="#" style={{ fontSize: '18px', fontWeight: 'bold' }}>Aura Airlines</a>, All Right Reserved - 2023. V 1.1 Designed by <a href="#" style={{ fontSize: '18px', fontWeight: 'bold' }}>Aura Lanka</a>
                          </div>
                          
                      </div>
                  </div>
              </div>
          </div>

          {showButton && (
                <button className="btn btn-primary btn-lg-square back-to-top top-btn" onClick={scrollToTop}>
                <i className="bi bi-arrow-up"></i>
                </button>
            )}

    </>
  )
}

export default footer